import { Content, Header, HeaderLabel, InfoCard, Page } from '@backstage/core-components';
import { Tab, Tabs, Typography } from '@material-ui/core';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

const FIRST_TIME_USER_URL =
  'https://dm-us.informaticacloud.com/ma/sso/4xCjxRKQS2sf2Cjt9oElCg?returnUrl=https://cdmp-app.dm-us.informaticacloud.com/checkout/abbf6560-c299-42df-949d-300a635b4e92';
const SELF_SERVE_SUPPORT_PATH = '/create/templates/default/ba-orion-mosaic-dbops';

export const MosaicSelfServePage: FC = () => {
  const navigate = useNavigate();

  const handleFirstTimeUser = () => {
    window.open(FIRST_TIME_USER_URL, '_blank', 'noopener,noreferrer');
  };

  const handleSelfServe = () => {
    navigate(SELF_SERVE_SUPPORT_PATH);
  };

  return (
    <Page themeId="home">
      <Header title="Mosaic Self Serve" subtitle="Self-service options for Mosaic access">
        <HeaderLabel label="Owner" value="Orion Infra Team" />
        <HeaderLabel label="Lifecycle" value="Alpha" />
      </Header>
      <Content>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <InfoCard>
            <Typography variant="body1" gutterBottom>
              Choose an option to get started with Mosaic.
            </Typography>
            <Tabs value={false} textColor="primary" indicatorColor="primary" aria-label="Mosaic self serve options">
              <Tab label="First Time User" onClick={handleFirstTimeUser} />
              <Tab label="Self Serve" onClick={handleSelfServe} />
            </Tabs>
          </InfoCard>
        </div>
      </Content>
    </Page>
  );
};
